module.exports = __webpack_public_path__ + "img/code@2x.ef0db5b8.png";